import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { ReportReadyPayload, User } from '../models/websocket.model';

@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket: Socket;

  constructor() {
    if (environment.enableSockets) {
      this.socket = io(environment.welbyEndpoint, {
        transports: ['websocket'],
      });
    }
  }

  joinPatientDetail(userId: string, name: string, id: string): void {
    if (!this.socket) {
      return;
    }
    this.socket.emit('userJoin', { id: userId, name, page: `patient-detail-${id}` });
  }

  onUserJoined(): Observable<string> {
    if (!this.socket) {
      return new Observable<string>((observer) => observer.complete());
    }
    return new Observable((observer) => {
      this.socket.on('userJoined', (msg: string) => observer.next(msg));
    });
  }

  onInitialUsersMessage(): Observable<string> {
    if (!this.socket) {
      return new Observable<string>((observer) => observer.complete());
    }
    return new Observable((observer) => {
      this.socket.on('initialUsersMessage', (msg: string) => observer.next(msg));
    });
  }

  leavePatientDetail(): void {
    if (!this.socket) {
      return;
    }
    this.socket.emit('userLeave');
  }

  onUsers(): Observable<User[]> {
    if (!this.socket) {
      return new Observable<User[]>((observer) => observer.complete());
    }
    return new Observable<User[]>((observer) => {
      this.socket.on('users', (users) => observer.next(users));
    });
  }

  onReportReady(jobId: string): Observable<ReportReadyPayload> {
    const reportsSocket = io(`${environment.welbyEndpoint}/reports`, {
      transports: ['websocket'],
    });

    return new Observable<ReportReadyPayload>((observer) => {
      reportsSocket.on('connect', () => {
        reportsSocket.emit('subscribe-report', jobId);
      });

      reportsSocket.on('report-ready', (payload: ReportReadyPayload) => {
        observer.next(payload);
        observer.complete();
        reportsSocket.disconnect();
      });

      reportsSocket.on('connect_error', (err: Error) => {
        observer.error(err);
        reportsSocket.disconnect();
      });

      return () => {
        reportsSocket.disconnect();
      };
    });
  }
}
